(() => {
  if (window.__restoreCarouselInit) return;
  window.__restoreCarouselInit = true;

  document.addEventListener('click', (event) => {
    // Carousels (reviews / you-may-also-like): arrows rotate the cards
    const arrow = event.target.closest('[data-carousel-arrow]');
    if (arrow) {
      const root = arrow.closest('[data-carousel]');
      const track = root.querySelector('[data-carousel-track]');
      if (track && track.children.length > 1) {
        if (arrow.dataset.carouselArrow === 'next') {
          track.append(track.firstElementChild);
        } else {
          track.prepend(track.lastElementChild);
        }
        const dots = Array.from(root.querySelectorAll('[data-carousel-dot]'));
        if (dots.length) {
          const current = dots.findIndex((d) => d.classList.contains('reviews__dot--active'));
          const delta = arrow.dataset.carouselArrow === 'next' ? 1 : -1;
          const next = (current + delta + dots.length) % dots.length;
          dots.forEach((d, i) => d.classList.toggle('reviews__dot--active', i === next));
        }
      }
      return;
    }

    const dot = event.target.closest('[data-carousel-dot]');
    if (dot) {
      const dots = dot.closest('[data-carousel]').querySelectorAll('[data-carousel-dot]');
      dots.forEach((d) => d.classList.toggle('reviews__dot--active', d === dot));
      return;
    }
  });

  // Wellness steps: theme editor block select shows that step's card
  document.addEventListener('shopify:block:select', (event) => {
    const card = event.target.closest('[data-wellness-card]');
    if (!card) return;
    const scroller = card.closest('[data-wellness-steps]');
    if (!scroller) return;
    scroller.querySelectorAll('[data-wellness-card]').forEach((c) => {
      c.classList.toggle('wellness-step--active', c === card);
    });
  });

  // Wellness steps: scroll reveals one card at a time — old image/text
  // fade out, new image/text fade in, sticky-pinned while scrolling.
  document.querySelectorAll('[data-wellness-steps]').forEach((scroller) => {
    const triggers = scroller.querySelectorAll('[data-wellness-trigger]');
    const cards = scroller.querySelectorAll('[data-wellness-card]');
    if (!triggers.length || !cards.length) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    scroller.classList.add('is-enhanced');

    const setActive = (step) => {
      cards.forEach((card) => {
        card.classList.toggle('wellness-step--active', card.dataset.step === step);
      });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.dataset.step);
        });
      },
      { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
    );

    triggers.forEach((trigger) => observer.observe(trigger));
  });
})();

// FAQ: keep only one item open at a time
const faqItems = document.querySelectorAll('.faq__item');
faqItems.forEach((item) => {
  item.addEventListener('toggle', () => {
    if (!item.open) return;
    faqItems.forEach((other) => {
      if (other !== item) other.open = false;
    });
  });
});

